import React, { useState } from 'react';
import { ClickAwayListener, Grid, Popper } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Button,
  Filter,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import AutocompleteWithCheckBoxes from '../../atoms/Autocomplete';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import { commonDropDownProps } from '../../atoms/ReportsCohortItem';

interface FilterOption {
  label: string;
  options: string[];
  selected: string[];
   
  onChange: (value: string[]) => void;
}

interface MultiFilterComponentProps {
  filterOptions: FilterOption[];
}

const useStyles = makeStyles()({
  filterContainer: {
    display: 'flex',
    gap: '1rem',
  },
  selectedFiltersContainer: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
  },
});

export const MultiFilterComponent: React.FC<MultiFilterComponentProps> = ({
  filterOptions,
}) => {
  const { classes } = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [activeFilter, setActiveFilter] = useState<string | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'multi-filter-popper' : undefined;

  return (
    <Grid className={classes.filterContainer}>
      <Button
        aria-describedby={id}
        label="Add Filter"
        startIcon={<Filter />}
        onClick={handleClick}
        height="37px"
      />
      {/* <div className={classes.selectedFiltersContainer}>
        {filterOptions.map((filter, idx) =>
          filter.selected.length > 0 ? (
            <span key={filter.label}>
              <strong>{filter.label}:</strong> {filter.selected.join(', ')}
            </span>
          ) : null,
        )}
      </div> */}
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        disablePortal={false}
        placement="bottom-start"
        style={{ marginTop: '0.25rem', zIndex: 2000, width: '180px' }}
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Dropdown
            label="Select Filter Type"
            placeholder="Select Filter Type"
            dropDownOptions={filterOptions.map((f) => f.label)}
            dropDownValues={filterOptions.map((f) => f.label)}
            value={activeFilter || ''}
            handleChange={(event) => {
              setActiveFilter(event.target.value as string);
              setAnchorEl(null);
            }}
            style={{ width: '180px' }}
            selectStyles={{
              ...commonDropDownProps.selectStyles,
              width: '100%',
            }}
            labelTop="10px"
          />
        </ClickAwayListener>
      </Popper>
      {activeFilter &&
        filterOptions.map((filter) => {
          if (filter.label !== activeFilter) {
            return null;
          }

          const options = filter.options.map((option) =>
            typeof option === 'string' ? { name: option } : option,
          );

          const selectedOptions = options.filter((option) =>
            filter.selected.includes(option.name),
          );

          return (
            <AutocompleteWithCheckBoxes
              key={filter.label}
              placeholder={filter.label}
              options={options}
              defaultValue={selectedOptions} // ✅ use value, not defaultValue
              handleChange={(
                event: React.ChangeEvent<{}>,
                value: Array<{ name: string } | string>,
              ) => {
                const selectedStrings = value.map((v: any) =>
                  typeof v === 'string' ? v : v.name,
                );
                const uniqueSelectedStrings = Array.from(
                  new Set(selectedStrings),
                );
                filter.onChange(uniqueSelectedStrings);
              }}
              width="200px"
              dropdownWidth="400px"
              fullWidthText
              disableClearAll={true}
              getOptionLabel={(option) => option.name ?? option}
            />
          );
        })}
    </Grid>
  );
};
